import styled from 'styled-components';
import type { CSSObject } from 'styled-components';

import type { ThemeType } from '@n3/css-base';

import { makeDefaultCellStyle } from './style';

import type { TdProps, TdComponent } from './types';

export const getHoverStyle = ({ colors, table }: ThemeType): CSSObject => ({
  position: 'relative',
  boxShadow: `-1px -1px 0 -1px ${colors[table.TD_BACKGROUND_SHADOW_COLOR]}, 1px -1px 0 -1px ${colors[table.TD_BACKGROUND_SHADOW_COLOR]}, -1px 2px 0 -1px ${colors[table.TD_BACKGROUND_SHADOW_COLOR]}, 1px 2px 0 -1px ${colors[table.TD_BACKGROUND_SHADOW_COLOR]}`,
  backgroundColor: colors[table.TD_BACKGROUND_COLOR_HOVER],
  borderBottomColor: colors.LAYER_ACCENT_01,
});

export const Td: string & TdComponent = styled.td<TdProps>((props) => {
  const {
    theme,
    theme: { fonts, colors, table },
  } = props;

  const firstRowBorder = `2px solid ${colors[table.TD_BORDER_COLOR_FIRST_ROW]}`;
  const solidBorder = `1px solid ${colors[table.TD_BORDER_COLOR]}`;

  return {
    ...makeDefaultCellStyle(props),
    ...fonts.DEFAULT,
    color: colors[table.TD_COLOR],
    padding: table.TD_PADDING,
    borderTop: solidBorder,
    borderBottom: solidBorder,
    borderLeft: props.hasBorderLeft ? solidBorder : undefined,
    borderRight: props.hasBorderRight ? solidBorder : undefined,

    'tbody > tr:first-child > &': {
      borderTop: firstRowBorder,
    },

    'tbody > tr:nth-child(2n+1) > &': {
      backgroundColor: table.ODD_ROW_BACKGROUND,
    },

    'tbody > tr:hover > &': getHoverStyle(theme),

    'tr:last-child > &': {
      borderBottom: solidBorder,
    },
  };
});
